// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__vw-XG","embed":"Layout_embed__1tH1q","content":"Layout_content__3UNCT"};